var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.50226 10.0047C9.87174 10.0047 11.0576 9.51172 12.0266 8.53909C12.9956 7.56666 13.4868 6.3768 13.4868 5.00221C13.4868 3.62803 12.9956 2.43805 12.0265 1.46525C11.0573 0.492948 9.87158 0 8.50226 0C7.13258 0 5.94696 0.492948 4.97803 1.46542C4.0091 2.43789 3.51773 3.62791 3.51773 5.00221C3.51773 6.3768 4.00906 7.56682 4.97819 8.53929C5.94732 9.5116 7.13306 10.0047 8.50226 10.0047ZM17.2238 15.9706C17.1958 15.566 17.1393 15.1244 17.0561 14.6583C16.9721 14.1886 16.864 13.7446 16.7345 13.3388C16.6008 12.9194 16.4189 12.5052 16.1941 12.1082C15.9607 11.6962 15.6866 11.3375 15.379 11.0423C15.0574 10.7335 14.6636 10.4852 14.2083 10.304C13.7545 10.1239 13.2516 10.0326 12.7137 10.0326C12.5025 10.0326 12.2982 10.1196 11.9036 10.3774C11.6231 10.5607 11.3418 10.7427 11.0597 10.9234C10.7886 11.0968 10.4214 11.2592 9.96774 11.4063C9.52519 11.55 9.07585 11.6229 8.63233 11.6229C8.18885 11.6229 7.73963 11.55 7.2966 11.4063C6.8435 11.2593 6.47625 11.097 6.20544 10.9236C5.89138 10.7222 5.60724 10.5384 5.36076 10.3772C4.96667 10.1194 4.76219 10.0324 4.55096 10.0324C4.01286 10.0324 3.51017 10.1238 3.05654 10.3042C2.6015 10.485 2.20758 10.7333 1.88564 11.0424C1.57825 11.3378 1.30401 11.6964 1.07095 12.1082C0.846301 12.5051 0.664414 12.9192 0.530506 13.339C0.401164 13.7448 0.293043 14.1886 0.209052 14.6583C0.125829 15.1238 0.0693227 15.5655 0.0413526 15.9711C0.0135289 16.3793 -0.000262246 16.7884 3.77572e-06 17.1976C3.77572e-06 18.2817 0.343405 19.1594 1.02059 19.8067C1.6894 20.4455 2.57434 20.7695 3.6505 20.7695H13.6151C14.6913 20.7695 15.5759 20.4457 16.2449 19.8068C16.9222 19.1599 17.2656 18.2821 17.2656 17.1974C17.2655 16.7789 17.2514 16.3661 17.2238 15.9706Z",
    fill: "url(#paint0_linear_208_867)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_208_867",
    x1: 1.74811e-7,
    y1: 20.7695,
    x2: 18.7906,
    y2: 19.2836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD297E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B01FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkUser);
export default __webpack_public_path__ + "static/media/dark-user.0047eed05955dc0e26c319d3cbb3d5b9.svg";
export { ForwardRef as ReactComponent };